import { combineReducers } from 'redux'
import DefaultReducers, { search } from 'reducers'
import seoContent from 'reducers/seoContent'
import algoliaReducer from 'reducers/algolia2/data'
export default combineReducers({ ...DefaultReducers, algolia: algoliaReducer, search, seoContent })